<template>
  <agent-status-settings
    :status-options="statusOptions"
    :default-status-key="defaultStatusKey"
    :target-key="targetKey"
    :show-sidebar="showSidebar"
    :is-initializing="isInitializing"
    :is-updating="isUpdating"
    @items-order-change="onItemsOrderChange"
    @open-create-sidebar="onOpenCreateSidebar"
    @open-update-sidebar="onOpenUpdateSidebar"
    @default-key-change="onDefaultKeyChange"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount } from 'vue-demi';
import AgentStatusSettings from '../components/AgentStatusSettings.vue';
import { useAgentStatusSettings } from '../composables';

export default defineComponent({
  name: 'AgentStatusSettingsContainer',
  components: { AgentStatusSettings },
  setup() {
    const {
      isInitializing,
      statusOptions,
      showSidebar,
      defaultStatusKey,
      targetKey,
      isUpdating,
      initializeAgentStatusSettings,
      onItemsOrderChange,
      onOpenCreateSidebar,
      onOpenUpdateSidebar,
      onDefaultKeyChange,
      onCancelTargetItem,
    } = useAgentStatusSettings();

    initializeAgentStatusSettings();

    onBeforeUnmount(onCancelTargetItem);

    return {
      isInitializing,
      statusOptions,
      showSidebar,
      defaultStatusKey,
      targetKey,
      isUpdating,
      onItemsOrderChange,
      onOpenCreateSidebar,
      onOpenUpdateSidebar,
      onDefaultKeyChange,
      onCancelTargetItem,
    };
  },
});
</script>
